import '../../scss/vitrine-boutique.scss'
import { SSEInit } from '../dataProvider/SSEManager.js'
import { accessibility } from '../modules/accessibility.js'
import { SG1Logs } from '../modules/logs.js'
import { carrouselOrchestrator } from '../componentsOrchestrator/carrouselOrchestrator.js'
import { metadataOrchestrator } from '../componentsOrchestrator/metadataOrchestrator.js'

try {
   SG1Logs.init()

   document.addEventListener('sseEndOfTransmition', () => {
      accessibility()
   })

   const specificOrchestratorHandler = {
      carrousel: carrouselOrchestrator,
      metaData: metadataOrchestrator,
   }

   SSEInit('boutique_events', specificOrchestratorHandler)

} catch (error) {
   console.error('BOUTIQUE orchestrator', error)
   SG1Logs.incLog('Err_PORCH')
   SG1Logs.sentryEvent({ error: error, name: 'Page Orchestrator' })
}